import configuration from './configuration.module'

export default {
  configuration,
}
